var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAppleLogo = function SvgAppleLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 35,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    x: 0.5,
    fill: "#000",
    fillOpacity: 0.2,
    rx: 17.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.75,
    d: "M23.076 17.636a4.55 4.55 0 0 1 2.161-3.814 4.65 4.65 0 0 0-3.661-1.981c-1.54-.162-3.034.923-3.82.923-.8 0-2.008-.907-3.31-.88a4.87 4.87 0 0 0-4.103 2.505c-1.775 3.075-.451 7.595 1.248 10.08.85 1.218 1.845 2.578 3.145 2.53 1.273-.053 1.748-.813 3.284-.813 1.522 0 1.968.813 3.294.782 1.366-.022 2.226-1.223 3.047-2.451a10 10 0 0 0 1.393-2.84 4.39 4.39 0 0 1-2.678-4.041M20.569 10.206A4.48 4.48 0 0 0 21.59 7a4.55 4.55 0 0 0-2.942 1.524 4.26 4.26 0 0 0-1.05 3.088 3.76 3.76 0 0 0 2.97-1.406"
  })));
};
export default SvgAppleLogo;